import styled from 'styled-components'
import { Box } from 'ui'

export const previewTokens = {
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    inset: '#F7F7F7',
    badge: '#F3F2F7',
    text: '#000',
    muted: '#6B6B6B',
    border: '#E8E8E8',
    infoSurface: '#DBEAFF',
    infoText: '#2F5FA8',
  },
  spacing: {
    gutter: '14px',
    gap: '14px',
    cardPadding: '18px',
  },
  radii: {
    card: '24px',
    inner: '18px',
  },
  shadows: {
    low: '0 6px 18px rgba(0, 0, 0, 0.07)',
  },
} as const

export const PreviewContent = styled(Box)`
  min-height: 100%;
  padding: 20px 0 24px;
  background: ${previewTokens.colors.background};
  color: ${previewTokens.colors.text};
`

export const PreviewCard = styled(Box)`
  margin: 0 ${previewTokens.spacing.gutter} ${previewTokens.spacing.gap};
  padding: ${previewTokens.spacing.cardPadding};
  border-radius: ${previewTokens.radii.card};
  background: ${previewTokens.colors.surface};
  box-shadow: ${previewTokens.shadows.low};
`

export const PreviewInset = styled(Box)`
  border-radius: ${previewTokens.radii.inner};
  background: ${previewTokens.colors.inset};
`
